import { FormFieldsCategory } from 'theSource/types';
import { buildValidationSchema, generalValidations } from 'theSource/utils';

export const getValidationSchema = (
  categories: FormFieldsCategory[],
  requireTruthyBooleans = false
) => {
  const fields = (categories || []).flatMap((category) => category.fields);

  return buildValidationSchema(
    fields,
    generalValidations(requireTruthyBooleans)
  );
};
